import { render, staticRenderFns } from "./ruralContent.vue?vue&type=template&id=5367e60c&scoped=true"
import script from "./ruralContent.vue?vue&type=script&lang=js"
export * from "./ruralContent.vue?vue&type=script&lang=js"
import style0 from "./ruralContent.vue?vue&type=style&index=0&id=5367e60c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5367e60c",
  null
  
)

export default component.exports